import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { ThemeProvider } from "@/components/theme-provider.tsx";
import { ErrorBoundary } from "@/components/ErrorBoundary.tsx";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { initSentry } from "@/lib/sentry";
import "./index.css";

// Initialize Sentry before React renders to capture early errors
initSentry();

// Service worker registration is handled by vite-plugin-pwa (auto-update mode).
// Push notification handlers are loaded via importScripts in the Workbox config.

// Vercel analytics/speed-insights scripts are served from `/_vercel/*` on
// Vercel's edge only — on any other host (localhost, CI test runner) they 404
// and log console errors. Gate them to the deployed domains so the home-page
// smoke test ("no console errors") stays clean off-Vercel.
const onVercel =
  typeof window !== "undefined" &&
  /(\.vercel\.app|jesusenteredthechat\.com)$/.test(window.location.hostname);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <App />
        {onVercel && (
          <>
            <Analytics />
            <SpeedInsights />
          </>
        )}
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
